import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './../styles/ProfilePage.css';
import profileService from './../services/ProfileService';
import { useAuth } from '../context/AuthContext';
import { FaSearch, FaUserAlt } from 'react-icons/fa';
import LoadingSpinner from '../utils/LoadingSpinner';
import InformationSection from './InformationSection';
import Button from './ui/Button';

const ProfilePage = () => {
  const [profile, setProfile] = useState(null);
  const [transgressorRef, setTransgressorRef] = useState('');
  const [searchRef, setSearchRef] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useAuth();
  const [currentTab, setCurrentTab] = useState('profile');
  const location = useLocation();

  // Check if transgressorRef exists in query parameters
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramTransgressorRef = params.get('transgressorRef');
    if (paramTransgressorRef) {
      setTransgressorRef(paramTransgressorRef);
      setSearchRef(paramTransgressorRef);
    }
  }, [location.search]);

  // Fetch profile data when transgressorRef is set
  useEffect(() => {
    if (!transgressorRef) return;
    async function fetchProfile() {
      setIsLoading(true);
      setError(null);
      try {
        const profileData = await profileService.getProfile(transgressorRef, token);
        if (Array.isArray(profileData) && profileData.length > 0) {
          setProfile(profileData[0]);
        } else {
          setProfile(profileData);
          setError('No profile found for the given Visor ID.');
        }
      } catch (err) {
        setError(err.message);
        setProfile(null);
      } finally {
        setIsLoading(false);
      }
    }
    fetchProfile();
  }, [transgressorRef, token]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setTransgressorRef(searchRef);
  };

  return (
    <div className="report-container">
      <div className="profile-tab-bar">
        <button
          className={currentTab === 'profile' ? 'active' : ''}
          onClick={() => setCurrentTab('profile')}
        >
          <FaUserAlt className="reports-font-style-dark" /> Profile Page Information
        </button>
      </div>
<InformationSection filePath="md/profile.md" />
      {currentTab === 'profile' && (
        <div className="profile-tab-content">
          
          <form className="profile-search-form" onSubmit={handleSubmit}>
            <div className="profile-advanced-search">
              <div className="profile-search-group">
                <div className="profile-search-input-group">
                  <span className="profile-search-input-group-text">
                    <FaSearch />
                  </span>
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <input
                      type="text"
                      placeholder="Enter Visor ID"
                      value={searchRef}
                      onChange={(e) => setSearchRef(e.target.value)}
                      className="report-search-form-control"
                    />
                  </div>
                </div>
                <Button 
                type="submit" 
                //className="profile-search-btn"
                >
                  Search
                </Button>
              </div>
            </div>
          </form>

          {isLoading && <LoadingSpinner />}
          {error && <div className="profile-error">Error: {error}</div>}

          {profile && (
            <div className="profile-card">
              <div className="profile-header">
                <h2>{profile.username}</h2>
                <p>{profile.groupName}</p>
              </div>
              <div className="profile-details">
                <div className="profile-item">
                  <span className="label">Total Images</span>
                  <span className="value">{profile.totalImages}</span>
                </div>
                <div className="profile-item">
                  <span className="label">Reviewed Images</span>
                  <span className="value">{profile.totalReviewedImages}</span>
                </div>
                <div className="profile-item">
                  <span className="label">Positive Images</span>
                  <span className="value">{profile.totalPositiveImages}</span>
                </div>
                <div className="profile-item">
                  <span className="label">Important Images</span>
                  <span className="value">{profile.totalImportantImages}</span>
                </div>
                <div className="profile-item">
                  <span className="label">Quarantined Images</span>
                  <span className="value">{profile.totalQuarantinedImages}</span>
                </div>
                <div className="profile-item">
                  <span className="label">Action Requiered Images</span>
                  <span className="value">{profile.totalActionRequiered}</span>
                </div>
              </div>
              <div className="profile-footer">
                <span>
                  Activated: {new Date(profile.activatedDate).toLocaleDateString()}
                </span>
                <span>Created: 30 days ago</span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
